/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {convertFetchResponseToReactQueryResponse} from '../tools';
import {ApiResponse} from '../types';
import {
    useMutation,
    UseMutationOptions,
    UseMutationResult,
    useQuery,
    useQueryClient,
    UseQueryOptions,
    UseQueryResult,
    QueryClient,
    useInfiniteQuery,
    UseInfiniteQueryOptions,
    UseInfiniteQueryResult,
} from 'react-query';
import {
    AdminUser,
    AdminUserFromJSON,
    AdminUserToJSON,
    CreateUser,
    CreateUserFromJSON,
    CreateUserToJSON,
    CreateUserResponse,
    CreateUserResponseFromJSON,
    CreateUserResponseToJSON,
} from '../models';

import {AdminApi, AdminApiAdminCreateUserRequest} from './AdminApi';

type AdminAllUsersQueryOptions = UseQueryOptions<Array<AdminUser>, Array<Error>, Array<AdminUser>, ['adminAllUsers']>;

let useAdminAllUsersQueryGlobalOptions:
    | ((queryClient: QueryClient, options?: AdminAllUsersQueryOptions) => AdminAllUsersQueryOptions | undefined)
    | undefined = undefined;

export function registerUseAdminAllUsersQueryGlobalOptions(
    callback: (queryClient: QueryClient, options?: AdminAllUsersQueryOptions) => AdminAllUsersQueryOptions | undefined
) {
    useAdminAllUsersQueryGlobalOptions = callback;
}

export function getAdminAllUsersQueryKey(): ['adminAllUsers'] {
    return ['adminAllUsers'];
}

export function useAdminAllUsersQuery(
    options?: AdminAllUsersQueryOptions
): UseQueryResult<Array<AdminUser>, Array<runtime.ApiError>> {
    const queryClient = useQueryClient();
    return useQuery(
        getAdminAllUsersQueryKey(),
        async ({signal}) => convertFetchResponseToReactQueryResponse(await new AdminApi().adminAllUsers({signal})),
        {
            ...options,
            ...useAdminAllUsersQueryGlobalOptions?.(queryClient, options),
        }
    );
}

type AdminAllUsersMutationOptions = UseMutationOptions<Array<AdminUser>, Array<Error>>;

let useAdminAllUsersMutationGlobalOptions:
    | ((queryClient: QueryClient, options?: AdminAllUsersMutationOptions) => AdminAllUsersMutationOptions | undefined)
    | undefined = undefined;

export function registerUseAdminAllUsersMutationGlobalOptions(
    callback: (
        queryClient: QueryClient,
        options?: AdminAllUsersMutationOptions
    ) => AdminAllUsersMutationOptions | undefined
) {
    useAdminAllUsersMutationGlobalOptions = callback;
}

export function useAdminAllUsersMutation(
    options?: AdminAllUsersMutationOptions
): UseMutationResult<Array<AdminUser>, Array<runtime.ApiError>, void> {
    const queryClient = useQueryClient();
    return useMutation(
        async (params) => convertFetchResponseToReactQueryResponse(await new AdminApi().adminAllUsers()),
        {
            ...options,
            ...useAdminAllUsersMutationGlobalOptions?.(queryClient, options),
        }
    );
}

export function getAdminAllUsersInfiniteQueryKey(): ['adminAllUsers-infinite'] {
    return ['adminAllUsers-infinite'];
}

export function useAdminAllUsersInfiniteQuery(
    options?: Omit<
        UseInfiniteQueryOptions<
            Array<AdminUser>,
            Array<runtime.ApiError>,
            Array<AdminUser>,
            Array<AdminUser>,
            ['adminAllUsers-infinite']
        >,
        'queryKey' | 'queryFn' | 'getNextPageParam'
    >
): UseInfiniteQueryResult<Array<AdminUser>, Array<runtime.ApiError>> {
    return useInfiniteQuery(
        getAdminAllUsersInfiniteQueryKey(),
        async (context) => convertFetchResponseToReactQueryResponse(await new AdminApi().adminAllUsers()),
        {
            ...options,
            getNextPageParam(lastPage, allPages) {
                const totalPages = (lastPage as any)?.totalPages || 0;
                if (allPages.length >= totalPages) {
                    return undefined;
                }
                return allPages.length + 1;
            },
        }
    );
}

type AdminCreateUserQueryOptions = UseQueryOptions<
    CreateUserResponse,
    Array<Error>,
    CreateUserResponse,
    ['adminCreateUser', AdminApiAdminCreateUserRequest]
>;

let useAdminCreateUserQueryGlobalOptions:
    | ((
          queryClient: QueryClient,
          params: AdminApiAdminCreateUserRequest,
          options?: AdminCreateUserQueryOptions
      ) => AdminCreateUserQueryOptions | undefined)
    | undefined = undefined;

export function registerUseAdminCreateUserQueryGlobalOptions(
    callback: (
        queryClient: QueryClient,
        params: AdminApiAdminCreateUserRequest,
        options?: AdminCreateUserQueryOptions
    ) => AdminCreateUserQueryOptions | undefined
) {
    useAdminCreateUserQueryGlobalOptions = callback;
}

export function getAdminCreateUserQueryKey(
    params: AdminApiAdminCreateUserRequest
): ['adminCreateUser', AdminApiAdminCreateUserRequest] {
    return ['adminCreateUser', params];
}

export function useAdminCreateUserQuery(
    params: AdminApiAdminCreateUserRequest,
    options?: AdminCreateUserQueryOptions
): UseQueryResult<CreateUserResponse, Array<runtime.ApiError>> {
    const queryClient = useQueryClient();
    return useQuery(
        getAdminCreateUserQueryKey(params),
        async ({signal}) =>
            convertFetchResponseToReactQueryResponse(await new AdminApi().adminCreateUser(params, {signal})),
        {
            ...options,
            ...useAdminCreateUserQueryGlobalOptions?.(queryClient, params, options),
        }
    );
}

type AdminCreateUserMutationOptions = UseMutationOptions<
    CreateUserResponse,
    Array<Error>,
    AdminApiAdminCreateUserRequest
>;

let useAdminCreateUserMutationGlobalOptions:
    | ((
          queryClient: QueryClient,
          options?: AdminCreateUserMutationOptions
      ) => AdminCreateUserMutationOptions | undefined)
    | undefined = undefined;

export function registerUseAdminCreateUserMutationGlobalOptions(
    callback: (
        queryClient: QueryClient,
        options?: AdminCreateUserMutationOptions
    ) => AdminCreateUserMutationOptions | undefined
) {
    useAdminCreateUserMutationGlobalOptions = callback;
}

export function useAdminCreateUserMutation(
    options?: AdminCreateUserMutationOptions
): UseMutationResult<CreateUserResponse, Array<runtime.ApiError>, AdminApiAdminCreateUserRequest> {
    const queryClient = useQueryClient();
    return useMutation(
        async (params) => convertFetchResponseToReactQueryResponse(await new AdminApi().adminCreateUser(params)),
        {
            ...options,
            ...useAdminCreateUserMutationGlobalOptions?.(queryClient, options),
        }
    );
}

export function getAdminCreateUserInfiniteQueryKey(
    params: AdminApiAdminCreateUserRequest
): ['adminCreateUser-infinite', AdminApiAdminCreateUserRequest] {
    return ['adminCreateUser-infinite', params];
}

export function useAdminCreateUserInfiniteQuery(
    params: AdminApiAdminCreateUserRequest,
    options?: Omit<
        UseInfiniteQueryOptions<
            CreateUserResponse,
            Array<runtime.ApiError>,
            CreateUserResponse,
            CreateUserResponse,
            ['adminCreateUser-infinite', AdminApiAdminCreateUserRequest]
        >,
        'queryKey' | 'queryFn' | 'getNextPageParam'
    >
): UseInfiniteQueryResult<CreateUserResponse, Array<runtime.ApiError>> {
    return useInfiniteQuery(
        getAdminCreateUserInfiniteQueryKey(params),
        async (context) =>
            convertFetchResponseToReactQueryResponse(
                await new AdminApi().adminCreateUser({
                    ...params,
                    page: context.pageParam || (params as any)?.page,
                } as any)
            ),
        {
            ...options,
            getNextPageParam(lastPage, allPages) {
                const totalPages = (lastPage as any)?.totalPages || 0;
                if (allPages.length >= totalPages) {
                    return undefined;
                }
                return allPages.length + 1;
            },
        }
    );
}
